import type { ApolloClient } from "@apollo/client";
import { logoutMutation, navigationUrl } from "./mobile-contract";

let logoutHandler: (() => Promise<void>) | undefined;
export const registerMobileLogout = (handler: () => Promise<void>) => {
  logoutHandler = handler;
};
export function isMobileSession(token: string | null) {
  try {
    const payload = token?.split(".")[1];
    return (
      !!payload &&
      !!JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")))
        .smx_session
    );
  } catch {
    return sessionStorage.getItem("smx_mobile_session") === "1";
  }
}
export const logoutMobileSession = () => logoutHandler?.();
export async function performMobileLogout(
  client: ApolloClient<object>,
  origin: string,
  clear: () => void | Promise<void>,
  loginPath: string,
) {
  let url = loginPath;
  let revoked = false;
  try {
    const result = await client.mutate({
      mutation: logoutMutation,
      fetchPolicy: "no-cache",
      context: { noRetry: true },
    });
    const body = result.data?.logoutStudent;
    revoked = !result.errors?.length && body?.localRevoked === true;
    if (body?.logoutUrl)
      url = navigationUrl(
        body.logoutUrl,
        origin,
        "/api/auth/smartmatrix/mobile/logout",
      );
  } catch {
    /* Browser cleanup is still required when revocation is unavailable. */
  }
  await clear();
  sessionStorage.removeItem("smx_mobile_session");
  sessionStorage.removeItem("smartmatrix_sso_session");
  try {
    await client.clearStore();
  } catch {
    /* Do not retain browser authorization. */
  }
  if (!revoked)
    window.alert(
      "You have been signed out in this browser. Server sign-out could not be confirmed. Contact your institute if you need help securing your session.",
    );
  window.location.assign(url);
}
